// extracted by mini-css-extract-plugin
export default {"tickColour":"#000","overlay":"SuccessOverlay--overlay--8e7ec1","container":"SuccessOverlay--container--c3b26e","message":"SuccessOverlay--message--d41631"};